<template>
    <div class="searchNews" @click="getNewsDetailInfo(news.id)">
        <h2>{{news.title}}</h2>
        <div class="s_content">
            <p>{{news.content}}</p>
        </div>
        <span>{{$t('footerNav[1]')}}</span>
    </div>
</template>

<script>
    export default {
        name: "searchNews",
        props:['news'],
        created:function () {
            // console.log(this.news)
        },
        methods:{
            getNewsDetailInfo(id){
                this.$router.push({
                    path: `/newsDetail/${id}`,
                })
            }
        }

    }
</script>

<style scoped lang="less">
    @import "../../assets/less/search";
    .searchNews {
        .s_layout;
    }

</style>
